import { useMutation } from '@tanstack/react-query';
import { OperationsApi } from '@Apis';
import { useTranslation } from 'react-i18next';
import { queryClient } from 'src/QueryClient';

interface UseMutationsProps {
  orgId: string;
  onSuccess?: () => void;
}

export const useEuqFeedbackMutations = ({
  orgId,
  onSuccess,
}: UseMutationsProps) => {
  const { t } = useTranslation(['operations', 'common']);

  const invalidateQueries = () => {
    // Invalidate content queries
    queryClient.invalidateQueries({
      queryKey: ['euqFeedback', orgId],
    });
    // Invalidate filter count queries
    queryClient.invalidateQueries({
      queryKey: ['euqFeedbackStatistic'],
    });
  };

  const approveMutation = useMutation({
    mutationFn: (ids: string[]) =>
      OperationsApi.apiBatchApproveEuqFeedback(ids),
    onSuccess: () => {
      invalidateQueries();
      onSuccess?.();
      window.showNotification({
        titleMsg: t('operations.euq.approveSuccess'),
        severity: 'success',
      });
    },
    onError: () => {
      window.showNotification({
        titleMsg: t('common.unknownError'),
        severity: 'error',
      });
    },
  });

  const rejectMutation = useMutation({
    mutationFn: (ids: string[]) => OperationsApi.apiBatchRejectEuqFeedback(ids),
    onSuccess: () => {
      invalidateQueries();
      onSuccess?.();
      window.showNotification({
        titleMsg: t('operations.euq.rejectSuccess'),
        severity: 'success',
      });
    },
    onError: () => {
      window.showNotification({
        titleMsg: t('common.unknownError'),
        severity: 'error',
      });
    },
  });

  return {
    approveMutation,
    rejectMutation,
  };
};
